import fetchServer from "../controllers/fetchServer";
import { URLdecode } from "../utils/url";
import { useRef } from "react";
import axios from "axios";
import { configurations } from "../configurations";
import { useDispatch, useSelector } from "react-redux";
import { setLeaderboard } from "../redux/reducers/pointsSlice";

export function useMilesPoints() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user?.userData);
  const cancelGetTasksToken = useRef(null);
  const cancelGetLogsToken = useRef(null);

  const getMilesPointsTasks = async ({ setLoading, callback }) => {
    const params = URLdecode();
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetTasksToken.current) {
      cancelGetTasksToken.current.cancel(cancellationMessage);
    }

    cancelGetTasksToken.current = axios.CancelToken.source();

    setLoading?.(true);

    await fetchServer({
      method: "GET",
      url: `/miles-point/v1/tasks`,
      // url: `/tasks`,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetTasksToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            callback?.(res?.data?.actions || []);
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const createReward = async ({ setLoading, callback, payload }) => {
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetTasksToken.current) {
      cancelGetTasksToken.current.cancel(cancellationMessage);
    }

    cancelGetTasksToken.current = axios.CancelToken.source();

    setLoading?.(true);

    await fetchServer({
      method: "POST",
      url: `/miles-point/v1/rewards/`,
      data: payload,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetTasksToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 201) {
            callback?.(res?.data?.reward || {});
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const getRewards = async ({
    setLoading,
    callback,
    limit = 10,
    page = 1,
    filter,
    sort,
  }) => {
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetTasksToken.current) {
      cancelGetTasksToken.current.cancel(cancellationMessage);
    }

    cancelGetTasksToken.current = axios.CancelToken.source();
    const searchParams = {
      limit,
      page,
      searchKey: filter,
      sortBy: `${sort?.orderBy}:${sort?.order}`,
    };
    if (!searchParams.searchKey || searchParams.searchKey === "all")
      delete searchParams.searchKey;
    let curUrl = new URLSearchParams(searchParams);

    setLoading?.(true);

    await fetchServer({
      method: "GET",
      url: `/miles-point/v1/rewards?` + curUrl,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetTasksToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            const rewards = res?.data?.rewards || [];
            callback?.(rewards, res?.data?.totalData || 0);
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const toggleReward = async ({ setLoading, callback, id }) => {
    setLoading?.(true);

    await fetchServer({
      method: "PATCH",
      url: `/miles-point/v1/rewards/toggle-status/${id}`,
      // api: configurations.milesPoints.base_url,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            const rewards = res?.data?.reward;
            callback?.(rewards);
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const updateReward = async ({ setLoading, callback, payload, id }) => {
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetTasksToken.current) {
      cancelGetTasksToken.current.cancel(cancellationMessage);
    }

    cancelGetTasksToken.current = axios.CancelToken.source();

    setLoading?.(true);

    await fetchServer({
      method: "PUT",
      url: `/miles-point/v1/rewards/${id}`,
      data: payload,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetTasksToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            callback?.(res?.data?.reward || {});
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const deleteReward = async ({ setLoading, callback, id }) => {
    setLoading?.(true);

    await fetchServer({
      method: "DELETE",
      url: `/miles-point/v1/rewards/${id}`,
      // api: configurations.milesPoints.base_url,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            const reward = res?.data?.reward;
            callback?.(reward);
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const getBadges = async ({
    setLoading,
    callback,
    limit = 10,
    page = 1,
    filter,
    sort,
  }) => {
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetTasksToken.current) {
      cancelGetTasksToken.current.cancel(cancellationMessage);
    }

    cancelGetTasksToken.current = axios.CancelToken.source();
    const searchParams = {
      limit,
      page,
      searchKey: filter,
      sortBy: `${sort?.orderBy}:${sort?.order}`,
    };
    if (!searchParams.searchKey || searchParams.searchKey === "all")
      delete searchParams.searchKey;
    let curUrl = new URLSearchParams(searchParams);

    setLoading?.(true);

    await fetchServer({
      method: "GET",
      url: `/miles-point/v1/badges?` + curUrl,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetTasksToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            const badges = res?.data?.badges || [];
            callback?.(badges, res?.data?.totalData || 0);
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const createBadge = async ({ setLoading, callback, payload }) => {
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetTasksToken.current) {
      cancelGetTasksToken.current.cancel(cancellationMessage);
    }

    cancelGetTasksToken.current = axios.CancelToken.source();

    setLoading?.(true);

    await fetchServer({
      method: "POST",
      url: `/miles-point/v1/badges/`,
      data: payload,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetTasksToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 201) {
            callback?.(res?.data?.badge || {});
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const updateBadge = async ({ setLoading, callback, payload, id }) => {
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetTasksToken.current) {
      cancelGetTasksToken.current.cancel(cancellationMessage);
    }

    cancelGetTasksToken.current = axios.CancelToken.source();

    setLoading?.(true);

    await fetchServer({
      method: "PUT",
      url: `/miles-point/v1/badges/${id}`,
      data: payload,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetTasksToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            callback?.(res?.data?.badge || {});
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const toggleBadge = async ({ setLoading, callback, id }) => {
    setLoading?.(true);

    await fetchServer({
      method: "PATCH",
      url: `/miles-point/v1/badges/toggle-status/${id}`,
      // api: configurations.milesPoints.base_url,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            const rewards = res?.data?.reward;
            callback?.(rewards);
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const deleteBadge = async ({ setLoading, callback, id }) => {
    setLoading?.(true);

    await fetchServer({
      method: "DELETE",
      url: `/miles-point/v1/badges/${id}`,
      // api: configurations.milesPoints.base_url,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            const badge = res?.data?.badge;
            callback?.(badge);
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const getMissions = async ({
    setLoading,
    callback,
    limit = 10,
    page = 1,
    filter,
    sort,
  }) => {
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetTasksToken.current) {
      cancelGetTasksToken.current.cancel(cancellationMessage);
    }

    cancelGetTasksToken.current = axios.CancelToken.source();
    const searchParams = {
      limit,
      page,
      searchKey: filter,
      sortBy: `${sort?.orderBy}:${sort?.order}`,
    };
    if (!searchParams.searchKey || searchParams.searchKey === "all")
      delete searchParams.searchKey;
    let curUrl = new URLSearchParams(searchParams);

    setLoading?.(true);

    await fetchServer({
      method: "GET",
      // url: `/missions?` + curUrl,
      url: `/miles-point/v1/missions?` + curUrl,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetTasksToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            const missions = res?.data?.missions || [];
            callback?.(missions, res?.data?.totalData || 0);
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const createMission = async ({ setLoading, callback, payload }) => {
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetTasksToken.current) {
      cancelGetTasksToken.current.cancel(cancellationMessage);
    }

    cancelGetTasksToken.current = axios.CancelToken.source();

    setLoading?.(true);

    await fetchServer({
      method: "POST",
      url: `/miles-point/v1/missions/`,
      data: payload,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetTasksToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 201) {
            callback?.(res?.data?.mission || {});
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const updateMission = async ({ setLoading, callback, payload, id }) => {
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetTasksToken.current) {
      cancelGetTasksToken.current.cancel(cancellationMessage);
    }

    cancelGetTasksToken.current = axios.CancelToken.source();

    setLoading?.(true);

    await fetchServer({
      method: "PUT",
      url: `/miles-point/v1/missions/${id}`,
      data: payload,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetTasksToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            callback?.(res?.data?.mission || {});
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const toggleMission = async ({ setLoading, callback, id }) => {
    setLoading?.(true);

    await fetchServer({
      method: "PATCH",
      url: `/miles-point/v1/missions/toggle-status/${id}`,
      // api: configurations.milesPoints.base_url,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            const mission = res?.data?.mission;
            callback?.(mission);
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const deleteMission = async ({ setLoading, callback, id }) => {
    setLoading?.(true);

    await fetchServer({
      method: "DELETE",
      url: `/miles-point/v1/missions/${id}`,
      // api: configurations.milesPoints.base_url,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            const mission = res?.data?.mission;
            callback?.(mission);
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const getMilesPointsLeaderboard = async ({
    setLoading,
    callback,
    // userId,
    // reload,
    search,
    filter,
  }) => {
    // if (details?._id && !reload && !userId) return;
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetTasksToken.current) {
      cancelGetTasksToken.current.cancel(cancellationMessage);
    }

    cancelGetTasksToken.current = axios.CancelToken.source();

    setLoading?.(true);

    const filterLib = {
      All: "",
      "This Week": "weekly",
      "This Month": "monthly",
      "This Year": "yearly",
    };

    await fetchServer({
      method: "GET",
      url: `/miles-point/v1/points/leaderboard?populate=userId&searchKey=${search}&filterBy=${filterLib[filter]}`,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetTasksToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            dispatch(setLeaderboard(res?.data?.result || []));
            callback?.(res?.data?.result);
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const getUserMilesPoints = async ({
    setLoading,
    callback,
    userId,
    reload,
  }) => {
    // console.log({ details, userId });
    if (!userId) return;
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetTasksToken.current) {
      cancelGetTasksToken.current.cancel(cancellationMessage);
    }

    cancelGetTasksToken.current = axios.CancelToken.source();
    const user = userId;
    // const user =
    //   "64f1b2c4a7e93f8d1b23c789" || userId || userData?.user?._id || "";

    setLoading?.(true);

    await fetchServer({
      method: "GET",
      url: `/miles-point/v1/points/user-points/${user}`,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetTasksToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            callback?.(res?.data?.pointDetails);
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const getMilesPointsLogs = async ({
    setLoading,
    callback,
    page = 1,
    limit = 10,
    userId,
  }) => {
    // if (transactions?.length) return;
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetLogsToken.current) {
      cancelGetLogsToken.current.cancel(cancellationMessage);
    }

    cancelGetLogsToken.current = axios.CancelToken.source();

    setLoading?.(true);

    await fetchServer({
      method: "GET",
      url: `/miles-point/v1/logs/${userId || user?._id}?page=${page}&limit=${limit}`,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetLogsToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            const result = res?.data;
            callback?.(result || {});
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  const getAllMilesPointsLogs = async ({
    setLoading,
    callback,
    page = 1,
    limit = 10,
  }) => {
    // if (transactions?.length) return;
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelGetLogsToken.current) {
      cancelGetLogsToken.current.cancel(cancellationMessage);
    }

    cancelGetLogsToken.current = axios.CancelToken.source();

    setLoading?.(true);

    await fetchServer({
      method: "GET",
      url: `/miles-point/v1/logs?page=${page}&limit=${limit}`,
      // api: configurations.milesPoints.base_url,
      cancelToken: cancelGetLogsToken.current.token,
    })
      .then((res) => {
        if (!res?.cancelled) setLoading?.(false);
        if (res) {
          if (res.status === 200) {
            const result = res?.data;
            callback?.(result || {});
          } else {
          }
        }
      })
      .catch((err) => {});
  };

  return {
    getMilesPointsTasks,
    createReward,
    getRewards,
    toggleReward,
    updateReward,
    deleteReward,
    createBadge,
    getBadges,
    getMissions,
    updateBadge,
    toggleBadge,
    deleteBadge,
    createMission,
    updateMission,
    toggleMission,
    deleteMission,
    getMilesPointsLeaderboard,
    getUserMilesPoints,
    getMilesPointsLogs,
    getAllMilesPointsLogs,
  };
}
